import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('Login realizado com sucesso!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Side - Login Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <img src="/logo.png" alt="Prefeitura de Carauari" className="h-20 mb-6" />
            <h1 className="text-3xl font-bold text-[#003366] mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Controle de Abastecimento
            </h1>
            <p className="text-slate-600">PREFEITURA DE CARAUARI</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                placeholder="seu.email@carauari.gov.br"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="email-input"
                className="focus-visible:ring-[#0066CC]"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <div className="relative">
                <Input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="password-input"
                  className="focus-visible:ring-[#0066CC] pr-10"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700"
                  data-testid="toggle-password-visibility"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              className="w-full bg-[#003366] hover:bg-[#002244] text-white h-11"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>

            <div className="text-center">
              <Link 
                to="/forgot-password" 
                className="text-sm text-[#0066CC] hover:underline"
                data-testid="forgot-password-link"
              >
                Esqueci minha senha
              </Link>
            </div>
          </form>

          <div className="mt-6 text-center">
            <p className="text-xs text-slate-400 mb-1">Sistema desenvolvido por</p>
            <p className="text-sm font-semibold text-[#003366]">N&M SERVICE RESOLUTION</p>
            <p className="text-xs text-slate-500">47036988000102</p>
          </div>
        </div>
      </div>

      {/* Right Side - Hero Image */}
      <div 
        className="hidden lg:flex flex-1 login-hero items-center justify-center p-12"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1644246905181-c3753e9a82bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxmdWVsJTIwc3RhdGlvbiUyMHB1bXAlMjBub3p6bGV8ZW58MHx8fHwxNzY5MTA5MTkyfDA&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="text-white text-center max-w-lg">
          <h2 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Gestão Eficiente da Frota Municipal
          </h2>
          <p className="text-xl text-white/90">
            Controle completo de abastecimentos, relatórios detalhados e dashboard em tempo real.
          </p>
        </div>
      </div>
    </div>
  );
}